import './Item.scss';

import cn from 'classnames';
import React from 'react';

// eslint-disable-next-line import/no-cycle
import Stocks from '@/ebat/components/blocks/Common/Stocks/Stocks';

import { ItemDefaultProps, ItemPropTypes } from './Item.proptypes';

const Item = ({
  batches,
  className,
  hasBatches,
  quantity,
  stock,
  unit,
  warehouse,
}) => (
  <div
    className={cn('stocks-details-item', className, {
      [`stocks-details-item--${hasBatches}`]: hasBatches,
    })}
  >
    <span
      className="stocks-details-item__warehouse"
      data-qa-id="stocks-details-item-warehouse"
    >
      {warehouse}
    </span>
    <ul
      className="stocks-details-item__quantity list"
      data-qa-id="stocks-details-item-quantity"
    >
      <li className="list__item">{`${quantity}${unit ? ` ${unit}` : ''}`}</li>
      {hasBatches &&
        batches.map((batch, index) => (
          <li className="list__item" key={`batch-quantity-${index}`}>
            {`${batch.stock_quantity}${unit ? ` ${unit}` : ''}`}
          </li>
        ))}
    </ul>
    <Stocks
      className="stocks-details-item__stock"
      origin="details"
      stock={stock}
      unit={unit}
    />
    {hasBatches && (
      <ul
        className="stocks-details-item__batches list"
        data-qa-id="stocks-details-item-batches"
      >
        <li className="list__item" />
        {batches.map((batch, index) => (
          <li
            className="list__item"
            data-qa-id="item-batches"
            key={`batch-code-${index}`}
          >
            {batch.id}
          </li>
        ))}
      </ul>
    )}
  </div>
);

Item.defaultProps = {
  ...ItemDefaultProps,
};

Item.propTypes = {
  ...ItemPropTypes,
};

export default Item;
